import React, { useState } from 'react';
import { MenuIcon, XIcon, PhoneIcon, MessageCircleIcon, GlobeIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { business } from '../data/business';
export function Navbar() {
  const {
    t,
    lang,
    toggle
  } = useLanguage();
  const [open, setOpen] = useState(false);
  const links = [{
    href: '#home',
    label: t.nav.home
  }, {
    href: '#services',
    label: t.nav.services
  }, {
    href: '#gallery',
    label: t.nav.gallery
  }, {
    href: '#about',
    label: t.nav.about
  }, {
    href: '#faq',
    label: t.nav.faq
  }, {
    href: '#contact',
    label: t.nav.contact
  }];
  return <nav className="border-b border-navy/10 bg-white" aria-label="Main" data-id="element-228" data-mp="ek76hfmromtf">
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between gap-6 px-4 sm:px-6 lg:px-8" data-id="element-229" data-mp="9k1nsoyh6anh">
        <a href="#home" className="font-display text-xl font-extrabold tracking-tight text-navy" data-id="element-230" data-mp="1pxi1w84jurrf">
          los <span className="text-brand-orange" data-id="element-231" data-mp="1kyewunokkljg">BROTHERS</span>
        </a>

        <ul className="hidden items-center gap-7 lg:flex" data-id="element-232" data-mp="9opvl9cr6h0l">
          {links.map(link => <li key={link.href} data-id="element-233" data-mp="enap6pxi22g2">
              <a href={link.href} className="text-sm font-medium text-ink/80 transition-colors duration-150 hover:text-brand-blue" data-id="element-234" data-mp="emiztwuhx0y8">
                {link.label}
              </a>
            </li>)}
        </ul>

        <div className="hidden items-center gap-3 lg:flex" data-id="element-235" data-mp="3n3ma4ooncyg4">
          <a href={business.phoneHref} className="flex items-center gap-2 text-sm font-semibold text-navy transition-colors duration-150 hover:text-brand-blue" data-id="element-236" data-mp="3n57164br5z98">
            <PhoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-237" data-mp="uuss7z3t2o4" />
            {business.phoneDisplay}
          </a>
          <a href={business.whatsappHref} target="_blank" rel="noreferrer" aria-label="WhatsApp" className="rounded-lg border border-navy/15 p-2 text-navy transition-colors duration-150 hover:border-brand-blue hover:text-brand-blue" data-id="element-238" data-mp="5op9d2jex1iz">
            <MessageCircleIcon className="h-4 w-4" aria-hidden="true" data-id="element-239" data-mp="318x5hke1brfy" />
          </a>
          <button type="button" onClick={toggle} aria-label={t.nav.language} className="flex items-center gap-1.5 rounded-lg border border-navy/15 px-2.5 py-2 text-xs font-bold uppercase text-navy transition-colors duration-150 hover:border-brand-blue hover:text-brand-blue" data-id="element-240" data-mp="2wa3y89pccwo8">
            <GlobeIcon className="h-4 w-4" aria-hidden="true" data-id="element-241" data-mp="2ddudj3jxp7v9" />
            {lang === 'en' ? 'EN' : 'ES'}
          </button>
          <a href="#contact" className="rounded-lg bg-brand-orange px-4 py-2.5 text-sm font-semibold text-white transition-colors duration-150 hover:bg-brand-orangeDark" data-id="element-242" data-mp="2sbmorjig7a3n">
            {t.nav.book}
          </a>
        </div>

        <div className="flex items-center gap-2 lg:hidden" data-id="element-243" data-mp="2l9nky4gnvn2">
          <a href="#contact" className="rounded-lg bg-brand-orange px-3 py-2 text-sm font-semibold text-white transition-colors duration-150 hover:bg-brand-orangeDark" data-id="element-244" data-mp="2krm9n2xyr8a">
            {t.nav.book}
          </a>
          <button type="button" onClick={() => setOpen(v => !v)} aria-expanded={open} aria-controls="mobile-menu" aria-label={open ? t.nav.close : t.nav.menu} className="rounded-lg border border-navy/15 p-2 text-navy" data-id="element-245" data-mp="14dp6g3v2txf">
            {open ? <XIcon className="h-5 w-5" aria-hidden="true" data-id="element-246" data-mp="xtbkq0jfqvvn" /> : <MenuIcon className="h-5 w-5" aria-hidden="true" data-id="element-247" data-mp="k3hwnkfr8fmz" />}
          </button>
        </div>
      </div>

      {open && <div id="mobile-menu" className="border-t border-navy/10 bg-white lg:hidden" data-id="element-248" data-mp="o30j4kn84yrx">
          <ul className="mx-auto max-w-7xl px-4 py-3 sm:px-6" data-id="element-249" data-mp="1btcmrjbfs9cp">
            {links.map(link => <li key={link.href} data-id="element-250" data-mp="1glnwfdvzb9ig">
                <a href={link.href} onClick={() => setOpen(false)} className="block border-b border-navy/5 py-3 text-base font-medium text-navy" data-id="element-251" data-mp="1gmpa7q4dqa3v">
                  {link.label}
                </a>
              </li>)}
          </ul>
          <div className="mx-auto flex max-w-7xl flex-wrap items-center gap-3 px-4 pb-4 sm:px-6" data-id="element-252" data-mp="3b25uirox2npu">
            <a href={business.phoneHref} className="flex items-center gap-2 rounded-lg border border-navy/15 px-3 py-2 text-sm font-semibold text-navy" data-id="element-253" data-mp="bn107uu4uiwr">
              <PhoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-254" data-mp="1x7s53t78lx9" />
              {business.phoneDisplay}
            </a>
            <button type="button" onClick={toggle} aria-label={t.nav.language} className="flex items-center gap-1.5 rounded-lg border border-navy/15 px-3 py-2 text-sm font-bold uppercase text-navy" data-id="element-255" data-mp="3u1jq1e2ao6ig">
              <GlobeIcon className="h-4 w-4" aria-hidden="true" data-id="element-256" data-mp="pkz3o56x0uxh" />
              {lang === 'en' ? 'EN' : 'ES'}
            </button>
          </div>
        </div>}
    </nav>;
}